import { render } from "./RepImage.vue?vue&type=template&id=5413bed8&scoped=true"
import script from "./RepImage.vue?vue&type=script&lang=js"
export * from "./RepImage.vue?vue&type=script&lang=js"

import "./RepImage.vue?vue&type=style&index=0&id=5413bed8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5413bed8"]])

export default __exports__